import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'nk-progress',
  imports: [],
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressComponent {
  /**  Use a variable and change opacity to toggle on and off the progress bar, so that the height does not change.*/
  @Input() public isLoading = false;
}
